export default __webpack_public_path__ + "static/media/health.dda1e657.png";